export default __webpack_public_path__ + "static/media/1817.fc20db14.png";